/**
 * NewTextComposerModal — Communications v2 "New text" launcher.
 *
 * Iter 507 · consolidated onto the shared `ContactPicker`. This file
 * is now a 30-line adapter that maps the (contact, endpointValue)
 * callback shape to the parent's expected onPick(last10, contact?).
 *
 * Testids preserved for regression compatibility:
 *   comms2-new-text-modal, comms2-new-text-close, comms2-new-text-search,
 *   comms2-new-text-contact-{id}, comms2-new-text-phone, comms2-new-text-go
 */
import ContactPicker from "../../components/contacts/ContactPicker";

const LAST10 = (s) => {
  const d = String(s || "").replace(/\D/g, "");
  return d.length >= 10 ? d.slice(-10) : "";
};

export default function NewTextComposerModal({ open, onClose, onPick }) {
  return (
    <ContactPicker
      open={open}
      onClose={onClose}
      onPick={(contact, endpointValue) => {
        const k = LAST10(endpointValue || contact?.phone_number);
        if (!k) return;
        onPick?.(k, contact);
      }}
      title="New text"
      channel="phone"
      allowDirectEntry
      testIdPrefix="comms2-new-text"
    />
  );
}
